import React from 'react';
import * as immutable from 'immutable';
import {cloneTopic, topicLink} from 'components/admin/topics/common';
import NewFilterWord from 'records/admin/topics/NewFilterWord';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import AdminFilterWordProfilePageActions from 'actions/admin/AdminFilterWordProfilePageActions';
import './TopicListItem.styl';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import classNames from 'classnames';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';
import {CloneIcon} from '@components/icon/CloneIcon';

interface TopicListItemProps {
  editable: boolean;
  topic: NewFilterWord;
  topicsSelectedForMerge: immutable.Set<NewFilterWord>;
  highlighted: boolean;
}

/**
 * An item in the list of topics on the admin topics page sidebar consisting of a checkbox for
 * merge selection, a link to the topic editor form, and a clone icon.
 */
export default class TopicListItem extends React.PureComponent<TopicListItemProps> {
  render() {
    const {editable, topic, topicsSelectedForMerge, highlighted} = this.props;
    const selectedForMerge = topicsSelectedForMerge.has(topic);
    return (
      <div
        className={classNames('admin-topics-list-topic-item', highlighted && 'highlighted')}
        key={topic.filterWordId}>
        <div className="topic-item-content">
          {editable && (
            <CheckboxField
              checked={selectedForMerge}
              onCheck={() => AdminFilterWordProfilePageActions.toggleTopicSelectedForMerge(topic)}
            />
          )}
          <div className="topic-name-wrapper">
            <div className="topic-link">{topicLink(topic)}</div>
            {editable && (
              <div className="clone-icon">
                <GenericTooltip
                  hoverBehavior
                  positionTop
                  delay={TOOLTIP_DELAY}
                  tooltip={'Clone This Topic'}>
                  <CloneIcon onClick={() => cloneTopic(topic)} />
                </GenericTooltip>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
